let appVersion = '0.0.0';

export default {
    get version () {
        return appVersion;
    },

    get versionWithoutHotfix () {
        const dashIndex = appVersion.indexOf("-");

        if (dashIndex > -1) {
            return appVersion.substring(0, dashIndex);
        }
        return appVersion;
    },

    set version (version) {
        appVersion = version;
    }
};
